

export const handleDownload = async (filePath: string,name?:string) => {
  // const imageUrl = 'http://localhost:8000/' + encodeURI(filePath);
    const imageUrl =  'https://api.hometownad.dcdev.kr/' + encodeURI(filePath);

    try {
        const response = await fetch(imageUrl, { mode: 'cors' }); // CORS 허용 필요
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        if(name){
            a.download = name;
        }
        // a.download = name ? name : 'download.png';
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        alert('다운로드 실패');
        console.error(err);
    }
};